import {HStack, Text, VStack} from "native-base";
import {Icon} from "../../Common/components/Icon";
import {faInfoCircle} from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import {OrdersTable} from "./Table/OrdersTable";
import React from "react";
import {usePendingOrdersList} from "../hooks/usePendingOrdersList";

export function PendingPickupNewtown() {
    const { loading, orders } = usePendingOrdersList(false);

    const newtownOrders = orders.filter(x => x.deliveryMethod === 'pickup-newtowndispensary' || x.deliveryMethod === 'pickup');
    return (
        <VStack space={2} flex={1}>
            <HStack space={2} alignItems={'center'}>
                <Icon icon={faInfoCircle} size={'sm'} />
                <Text>Scripts awaiting to be picked up</Text>
            </HStack>

            <OrdersTable orders={newtownOrders} loading={loading} />
        </VStack>
    );
}
